import { createSlice } from "@reduxjs/toolkit";
import { loadFromStorage } from "../storage";

const cartFromStorage = loadFromStorage("ramu_cart", (data) =>
  Array.isArray(data.items),
);

const initialState = cartFromStorage || {
  items: [],
  subtotal: 0,
  tax: 0,
  discount: 0,
  total: 0,
};

// const TAX_RATE = 0.18;

const recalculate = (state) => {
  const subtotal = state.items.reduce(
    (sum, item) => Number(sum) + Number(item.price),
    0,
  );
  state.subtotal = subtotal;
  // state.tax = +(subtotal * TAX_RATE).toFixed(2);
  // state.total = +(subtotal + state.tax - state.discount).toFixed(2);
  state.total = +(subtotal - state.discount).toFixed(2);
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;
      const existing = state.items.find((i) => i.id === item.id);

      if (!existing) {
        state.items.push(item);
      }

      recalculate(state);

      localStorage.setItem("ramu_cart", JSON.stringify(state));
    },

    incrementQuantity: (state, action) => {
      const item = state.items.find((i) => i.id === action.payload);
      if (item) {
        item.quantity = (item.quantity || 1) + 1;
      }
      recalculate(state);
    },

    decrementQuantity: (state, action) => {
      const id = action.payload;
      const item = state.items.find((i) => i.id === id);
      if (item) {
        if (item.quantity > 1) {
          item.quantity -= 1;
        } else {
          state.items = state.items.filter((i) => i.id !== id);
        }
      }
      recalculate(state);
    },

    removeFromCart: (state, action) => {
      const id = action.payload;

      state.items = state.items.filter((item) => item.id !== id);

      recalculate(state);

      localStorage.setItem(
        "ramu_cart",
        JSON.stringify({
          items: state.items,
          subtotal: state.subtotal,
          tax: state.tax,
          discount: state.discount,
          total: state.total,
        }),
      );
    },

    clearCart: (state) => {
      state.items = [];
      state.subtotal = 0;
      state.tax = 0;
      state.discount = 0;
      state.total = 0;

      localStorage.removeItem("ramu_cart");
    },

    restoreCart: (state, action) => {
      return action.payload || initialState;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  clearCart,
  restoreCart,
  incrementQuantity,
  decrementQuantity,
} = cartSlice.actions;

export default cartSlice.reducer;
